import { useGeotabClient } from "@/components/GeotabClientContext";

/** The address that exempts someone from the group-based permissions. */
const FAIRFLEET_EMAIL_SUFFIX = "@fairfleet.de";

/**
 * Whether the signed-in user is exempt from the group-based permissions.
 *
 * One place, because it is a rule about who may do things: spelled out separately wherever it is
 * needed, a later change — another address, a different way of recognising staff — would be made
 * in one of them and quietly not in the others.
 */
export function useIsFairfleetAdmin(): boolean {
  const { username } = useGeotabClient();
  return username?.endsWith(FAIRFLEET_EMAIL_SUFFIX) ?? false;
}
